// extracted by mini-css-extract-plugin
module.exports = {"productCard":"ProductCard_productCard__QWnOu"};